var CartOptionChoiceModel = /** @class */ (function () {
    function CartOptionChoiceModel(data) {
        // hack
        if (data.choice_id) {
            data = CartOptionChoiceModel.importModel(data);
        }
        this.id = data.id;
        if (!this.id || this.id === 'undefined') {
            var choiceString = JSON.stringify(data);
            console.error("Error choice does not have valid ID: " + choiceString);
        }
        this.parentId = data.parentId || '';
        this.required = data.required || false;
        this.siblingId = data.siblingId || '0';
        this.name = data.name;
        this.quantity = +(data.quantity);
        this.maxQuantity = +(data.maxQuantity) || 100;
        this.price = +(data.priceDelta) || +(data.price) || 0;
        this.selected = ((data.selected) ? true : false);
        this.includedQuantity = data.includedQuantity || 0;
        this.mutableQuantity = data.mutableQuantity || false;
        this.maxFractionalQuantity = +(data.maxFractionalQuantity || data.max_fractional_qty) || 4;
        this.fractionalQuantity = +(data.fractionalQuantity || data.fractional_qty) || 0;
        this.hasException = data.hasException || data.has_exception || null;
        this.hasMasterException = data.hasMasterException || data.is_master_exception || false;
        this.userSet = this.handleUserSet(data);
        this.freeChoice = data.freeChoice || 0;
        this.basePriceDelta = +(data.basePriceDelta) || 0;
        this.adjustQuantity();
        this.__mc = 'CartOptionChoiceModel';
    }
    // User Set has odd behavior - true if missing, otherwise use the set value
    CartOptionChoiceModel.prototype.handleUserSet = function (data) {
        if (typeof data.userSet !== 'undefined') {
            return data.userSet;
        }
        if (typeof data.is_user_set === 'undefined') {
            return true;
        }
        if (data.is_user_set === null) {
            return true;
        }
        return data.is_user_set;
    };
    CartOptionChoiceModel.prototype.adjustQuantity = function () {
        var choiceSelected = this.required || this.selected;
        var quantity = this.quantity;
        if (!quantity && choiceSelected) {
            this.quantity = 1;
        }
    };
    CartOptionChoiceModel.prototype.setParent = function (id) {
        this.parentId = id;
    };
    CartOptionChoiceModel.prototype.setSibling = function (siblingId) {
        this.siblingId = siblingId;
    };
    CartOptionChoiceModel.prototype.setQuantity = function (quantity) {
        this.quantity = quantity;
        if (this.quantity >= 1) {
            this.selected = true;
        }
        else {
            this.selected = false;
        }
        if (this.isFractional()) {
            this.fractionalQuantity = 1;
            this.selected = true;
        }
        else {
            this.fractionalQuantity = 0;
        }
        // TODO deal with fractional qty
    };
    CartOptionChoiceModel.prototype.getTotal = function () {
        var multiplier = Math.max(0, this.quantity - this.includedQuantity);
        return this.price * multiplier;
    };
    CartOptionChoiceModel.prototype.displayableQuantity = function () {
        var rv = "";
        if (!this.mutableQuantity && this.quantity <= 1) {
            return rv;
        }
        // no checkmarks in online store
        //
        if (this.selected || 1 <= this.quantity) {
            rv = rv + this.quantity;
        }
        else if (this.fractionalQuantity) {
            var nume = "1";
            var denom = "1";
            if (!(this.maxFractionalQuantity % this.fractionalQuantity)) {
                nume = "1";
                denom = "" + String(this.maxFractionalQuantity / this.fractionalQuantity);
            }
            else {
                nume = String(this.fractionalQuantity);
                denom = String(this.maxFractionalQuantity);
            }
            rv = nume + "/" + denom;
        }
        return rv;
    };
    CartOptionChoiceModel.prototype.displayFraction = function (quantity) {
        if (quantity === '0.5') {
            return 'Light';
        }
        return quantity;
    };
    CartOptionChoiceModel.prototype.configuredName = function () {
        var name = this.name;
        var isWhole = (this.siblingId === '0');
        var isIncluded = (this.includedQuantity >= 1);
        var isExtra = (this.quantity > this.includedQuantity);
        var isLess = (this.quantity < this.includedQuantity && 0 < this.quantity);
        if (this.quantity > 1) {
            name = "<strong class=\"truncate\">Extra " + name + "</strong>";
        }
        else if (this.isFractional()) {
            var displayableQuantity = this.displayableQuantity();
            var fraction = this.displayFraction(displayableQuantity);
            name = "<em class=\"truncate\">" + fraction + " " + name + "</em>";
        }
        if (isIncluded && (!this.selected && !this.quantity) || (this.isUserSet && (!this.quantity && !this.selected))) {
            name = "No " + name;
        }
        else if (isIncluded && this.selected && !isWhole) {
            var side = (this.siblingId === '1') ? '(left' : '(right';
            name = "<span class=\"truncate\">" + name + " <span class=\"small-font\">" + side + " only)</span></span>";
        }
        else if ((isIncluded && !isExtra && !isLess) || (!isIncluded && this.quantity === 0)) {
            name = '';
        }
        return name;
    };
    // TODO important note: will have to check for included toppings that are one side only.
    CartOptionChoiceModel.prototype.includedChoice = function () {
        var isIncluded = (this.includedQuantity > 0);
        var hasChanged = (this.quantity !== this.includedQuantity);
        var isDivided = (this.siblingId !== '0');
        var isRequired = (this.required);
        return (isIncluded && !hasChanged && !isDivided && !isRequired);
    };
    CartOptionChoiceModel.prototype.isUserSet = function () {
        if (this.userSet !== null) {
            return this.userSet;
        }
        var isIncluded = (this.includedQuantity > 0);
        var hasChanged = (this.quantity !== this.includedQuantity);
        var isDivided = (this.siblingId !== '0');
        var whole = (this.siblingId === '0');
        if (isIncluded && !hasChanged) {
            return false;
        }
        return (isIncluded && hasChanged) || isDivided || (whole && hasChanged);
    };
    CartOptionChoiceModel.prototype.isFractional = function () {
        return this.quantity < 1 && 0 < this.quantity;
    };
    CartOptionChoiceModel.prototype.getFractionalQuantity = function () {
        return (this.fractionalQuantity && this.maxFractionalQuantity)
            ? this.fractionalQuantity / this.maxFractionalQuantity
            : 0;
    };
    CartOptionChoiceModel.prototype.exportModel = function () {
        if (this.includedChoice() && !this.selected) {
            return null;
        }
        var exportedChoice = {
            choice_id: this.id,
            fractional_qty: 0,
            has_exception: this.hasException,
            included_qty: this.includedQuantity,
            is_user_set: this.isUserSet(),
            max_fractional_qty: this.maxFractionalQuantity,
            mutable_qty: this.mutableQuantity,
            name: this.name,
            price_delta: this.price,
            qty: "" + this.quantity,
            selected: this.selected,
        };
        // deals with fractional quantities
        if (this.isFractional()) {
            exportedChoice.qty = "0";
            exportedChoice.fractional_qty = this.fractionalQuantity;
        }
        if (this.hasMasterException) {
            exportedChoice['is_master_exception'] = true;
        }
        return exportedChoice;
    };
    // Rather than having a hydration function
    CartOptionChoiceModel.importModel = function (data) {
        var optionChoice = {};
        optionChoice['id'] = data.choice_id;
        optionChoice['parentId'] = data.parentId || '';
        optionChoice['hasException'] = data.has_exception;
        optionChoice['userSet'] = data.is_user_set;
        optionChoice['mutableQuantity'] = data.mutable_qty;
        optionChoice['price'] = data.price_delta;
        optionChoice['name'] = data.name;
        optionChoice['selected'] = data.selected;
        optionChoice['includedQuantity'] = data.included_qty || 0;
        optionChoice['quantity'] = data.qty || 0;
        return optionChoice;
    };
    return CartOptionChoiceModel;
}());
export default CartOptionChoiceModel;



//////////////////
// WEBPACK FOOTER
// ./src/models/CartOptionChoiceModel.ts
// module id = 5AfY
// module chunks = 18